"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePanzoom = void 0;
var _panzoom = _interopRequireDefault(require("panzoom"));
var _react = require("react");
const usePanzoom = containerRef => {
  const [panzoomInstance, setPanzoomInstance] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (containerRef.current) {
      const pan = (0, _panzoom.default)(containerRef.current, {
        beforeWheel: /* istanbul ignore next */() => true,
        bounds: true,
        boundsPadding: 1,
        maxZoom: 1.5,
        minZoom: 1,
        transformOrigin: {
          x: 0.5,
          y: 0.5
        },
        zoomDoubleClickSpeed: 1,
        zoomSpeed: 1,
        onTouch: /* istanbul ignore next */() => false
      });
      setPanzoomInstance(pan);
    }
  }, [containerRef]);
  const resetZoom = (0, _react.useCallback)(() => {
    if (panzoomInstance) {
      panzoomInstance.zoomTo(0, 0, 0);
    }
  }, [panzoomInstance]);
  const subscribeToTransform = (0, _react.useCallback)(observer => {
    if (panzoomInstance) {
      panzoomInstance.on('transform', event => {
        observer(event.getTransform());
      });
    }
  }, [panzoomInstance]);
  const zoom = (0, _react.useCallback)(scaleMultiplier => {
    if (panzoomInstance && containerRef.current) {
      const {
        width,
        height
      } = containerRef.current.getBoundingClientRect();
      panzoomInstance.smoothZoom(width / 2, height / 2, scaleMultiplier);
    }
  }, [panzoomInstance, containerRef]);
  return {
    subscribeToTransform,
    zoom,
    resetZoom
  };
};
exports.usePanzoom = usePanzoom;